import TablePasteParser from '../../lib/TablePasteParser';
import type { ISdkModel } from '../../store-manager';
import BasePrepareModel from './base-prepare-model';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';

class TablePrepareModel extends BasePrepareModel {
    public getHtml(htmlData: ISdkModel): string {
        const sdkData = this.getFirstSelectedElement(htmlData);
        const tableHtmlString = TablePasteParser.getSingleton().parseSdkDataToHtml(sdkData);
        const tableDocument = new DOMParser().parseFromString(tableHtmlString, 'text/html');
        const table = tableDocument.querySelector('table');
        if (!table) return '';
        this.insertPrivateData(table, htmlData);
        const html = tableDocument.querySelector('html') as Element;
        return html.outerHTML;
    }

    protected getFirstSelectedElement(selectedSdkDataArray: { data: any[]; }) {
        if (browser.isPc) {
            return selectedSdkDataArray?.data?.[0]?.inheritedSdkData;
        }
        return super.getFirstSelectedElement(selectedSdkDataArray);
    }
}

export default TablePrepareModel;
